export const validateFieldExists = (hit, Item) => Array.isArray(Item)
  ? Item.some(o => hit[o.field])
  : !!hit[Item.field]

export const getHeaderImg = img => img.includes('http') ? img : `https://pga.org${img}`
